import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import './Refer.css';

const rewards = [
  {
    emoji: '🏆',
    title: 'Claim Referral Bonanza',
    coins: '10 Coins',
    required: 10,
    desc: 'Claim Smart Watch, Earbuds etc. Requires 10 successful referrals and 10 Coins.',
  },
  {
    emoji: '🎟️',
    title: 'Lottery Entry Ticket',
    coins: '500 Coins',
    required: 500,
    desc: 'Redeem for one entry into the JustService24 Lottery.',
  },
];

export default function ReferEarn() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [referData, setReferData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [redeemModal, setRedeemModal] = useState(null);

  useEffect(() => {
    api.get('/api/referrals/my')
      .then(res => setReferData(res.data.data))
      .catch(() => {});
  }, []);

  const referCode = referData?.referralCode || user?.referralCode || `JUSTSERVICE${(user?.phone || '').slice(-4)}`;
  const availableCoins = referData?.balance || 0;
  const totalEarned = referData?.totalEarned || 0;
  const referredUsers = referData?.referredUsers || [];

  const copyCode = () => {
    navigator.clipboard.writeText(referCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="refer-page">
      {/* Dark gradient background */}
      <div className="refer-bg">
        {/* Dots */}
        {[...Array(12)].map((_, i) => (
          <div key={i} className="refer-dot" style={{
            left: `${[10,80,30,90,5,60,20,75,40,85,50,15][i]}%`,
            top: `${[10,15,30,40,50,60,75,80,90,95,20,65][i]}%`,
          }} />
        ))}

        <div className="refer-inner container">
          {/* Header */}
          <div className="refer-topbar">
            <button className="refer-back" onClick={() => navigate(-1)}>← Back</button>
            <span>🎁</span>
            <h2>JustService24 Rewards</h2>
            <button className="refer-history-btn" onClick={() => navigate('/redeem-history')}>📋</button>
          </div>

          <div className="refer-content">
            <h1>🎉 Exclusive Referral Bonanza!</h1>
            <p className="refer-sub">Refer 10 friends to JustService24 and unlock amazing rewards 🎁</p>

            {/* Coins Card */}
            <div className="coins-card">
              <div className="coins-icon">💰</div>
              <div style={{flex:1}}>
                <span className="coins-label">Available Balance</span>
                <div style={{color:'rgba(255,255,255,0.6)', fontSize:12, marginTop:2}}>Total Earned: ₹{totalEarned} &nbsp;|&nbsp; {referredUsers.length} Refer{referredUsers.length !== 1 ? 'rals' : 'ral'}</div>
              </div>
              <div className="coins-value">₹{availableCoins}</div>
            </div>

            {/* Referral Code */}
            <div className="refer-code-card">
              <span>🎁</span>
              <div className="refer-code-info">
                <p>Your Referral Code</p>
                <h3>{referCode}</h3>
              </div>
              <button className="copy-btn" onClick={copyCode}>
                {copied ? '✓' : '📋'}
              </button>
            </div>

            {/* Lottery Button */}
            <button className="btn-lottery">Lottery & More</button>

            {/* Rewards */}
            <div className="rewards-title">
              <span>🎲</span> Lottery & Special Rewards
            </div>

            {rewards.map((r, i) => (
              <div key={i} className="reward-card">
                <span className="reward-emoji">{r.emoji}</span>
                <div className="reward-info">
                  <h4>{r.title}</h4>
                  <p className="reward-coins">{r.coins}</p>
                  <p className="reward-desc">{r.desc}</p>
                </div>
                <button className="btn-redeem" onClick={() => setRedeemModal(r)}>Redeem</button>
              </div>
            ))}

            {/* Grand Gift Info */}
            <div className="grand-gift-box">
              <h3>🎁 Grand Gift Lottery Info</h3>
              <ul>
                <li>👉 100 successful referrals required.</li>
                <li>👉 10 winners per state.</li>
                <li>👉 Prizes: TVs, Phones, Watches, Earbuds & more.</li>
                <li>👉 Winners announced every quarter.</li>
              </ul>
            </div>

            {/* Share Button */}
            <button className="btn-share-refer" onClick={() => {
              navigator.clipboard.writeText(`Join JustService24! Use my code: ${referCode}\nhttp://www.justservice24.com`);
              alert('Share text copied!');
            }}>
              📤 Share & Invite Friends
            </button>
          </div>
        </div>
      </div>

      {/* Redeem Modal */}
      {redeemModal && (
        <div className="redeem-overlay" onClick={() => setRedeemModal(null)}>
          <div className="redeem-modal" onClick={e => e.stopPropagation()}>
            <span className="redeem-emoji">{availableCoins >= redeemModal.required ? '🎉' : '😔'}</span>
            <h3 style={{ color: availableCoins >= redeemModal.required ? '#00C853' : '#f44336' }}>
              {availableCoins >= redeemModal.required ? 'Congratulations!' : 'Insufficient Coins'}
            </h3>
            <p className="redeem-title">{redeemModal.title}</p>
            <div className="redeem-msg">
              {availableCoins >= redeemModal.required
                ? 'Your reward has been redeemed successfully! 🎁'
                : `You need ${redeemModal.required} Coins to redeem. You have only ${availableCoins} Coin. Refer more friends to earn coins!`
              }
            </div>
            <p className="redeem-auto">This dialog will close automatically...</p>
          </div>
        </div>
      )}
    </div>
  );
}
